import { makeStyles, createStyles } from '@material-ui/core';

export const formStyles = makeStyles(() =>
  createStyles({
    message: {
      width: "100%",
      marginBottom: 15,
      textAlign: 'center',
    },
    deleteWarn: {
      padding: '20px',
      display: 'flex',
      flexWrap: 'wrap',
      width: '250px',
      justifyContent: ' space-between',
    },
  }),
);
